import { Checkbox } from '@material-ui/core';
import * as React from 'react';
import { DSListItem, DSListItemIcon, DSListItemText } from '../../../mui';
import { PickerListItem } from './PickerListItem';
import { PickableClientOrLocationGroup } from './types';

export type PickerListItemGroupProps = {
    client: PickableClientOrLocationGroup;
    selected: ReadonlyArray<string>;
    disabled: ReadonlyArray<string>;
    onChange: (selected: string[]) => void;
};

export const PickerListItemGroup: React.FC<PickerListItemGroupProps> = ({ client, disabled, onChange, selected }) => {
    let areAllLocationsChecked = true;
    // Const isAtLeastOneLocationChecked = false;
    let areAllLocationsDisabled = true;

    const children = client.items.map(location => {
        const isChecked = selected.includes(location.id);
        areAllLocationsChecked &&= isChecked;
        // IsAtLeastOneLocationChecked = isAtLeastOneLocationChecked || isChecked;
        areAllLocationsDisabled &&= disabled.includes(location.id);
        return (
            <PickerListItem
                key={location.id}
                {...{ disabled, selected }}
                item={location}
                style={{ marginLeft: '16px' }}
                onChange={onChange}
            />
        );
    });

    return (
        <>
            <DSListItem
                button
                dense
                disabled={areAllLocationsDisabled}
                key={client.id}
                selected={areAllLocationsChecked}
                onClick={() => {
                    const locationIds = client.items
                        .filter(
                            location =>
                                !disabled.includes(location.id) &&
                                location.maxCollections - location.currentCollections > 0,
                        )
                        .map(({ id }) => id);
                    if (!areAllLocationsChecked) {
                        onChange([...selected, ...locationIds]);
                    } else {
                        onChange(selected.filter(id => !locationIds.includes(id)));
                    }
                }}
            >
                <DSListItemIcon>
                    <Checkbox
                        checked={areAllLocationsChecked}
                        color="primary"
                        disableRipple
                        edge="start"
                        inputProps={{ 'aria-labelledby': client.title }}
                        tabIndex={-1}
                    />
                </DSListItemIcon>
                <DSListItemText primary={client.title} primaryTypographyProps={{ style: { fontSize: '1rem' } }}>
                    {client.title}
                </DSListItemText>
            </DSListItem>
            {children}
        </>
    );
};
